module.exports = __webpack_public_path__ + "img/logoall_m.05e07d37.png";